import React from "react"
import { Row, Col, Image } from 'react-bootstrap';
import LazyLoad from "react-lazy-load";

import FactsAndFiguresIcon1 from '../images/facts-and-figures-icon-1.svg'
import FactsAndFiguresIcon2 from '../images/facts-and-figures-icon-2.svg'
import FactsAndFiguresIcon3 from '../images/facts-and-figures-icon-3.svg'
import FactsAndFiguresIcon4 from '../images/facts-and-figures-icon-4.svg'
import FactsAndFiguresIcon5 from '../images/facts-and-figures-icon-5.svg'

const WhyChooseFacts = () => {
  const whychoose = [
    {
      img: FactsAndFiguresIcon1,
      num: "14+",
      experience: "Years of experience",
      width: 52,
      height: 49
    },
    {
      img: FactsAndFiguresIcon2,
      num: "180+",
      experience: "Skilled talent",
      width: 52,
      height: 49
    },
    {
      img: FactsAndFiguresIcon3,
      num: "750+",
      experience: "Project delivered",
      width: 52,
      height: 49
    },
    {
      img: FactsAndFiguresIcon4,
      num: "92%",
      experience: "Client satisfaction rate",
      width: 52,
      height: 49
    },
    {
      img: FactsAndFiguresIcon5,
      num: "40+",
      experience: "Clients in countries",
      width: 50,
      height: 50
    },
  ]
  return (
    <>
      <Row xs={2} lg={5} className='g-5 mb-5 why-choose-line px-4'>
        {
          whychoose.map((item, index) => (
            <Col className={`${index === 4 ? " " : "contact-us-line-y"}`} key={index}>
              <div className='d-flex flex-column'>
                <LazyLoad offset={150}>
                  <i className='d-flex align-items-center icon-size-60 mb-3'>
                    <Image
                      loading='lazy'
                      className='lazyload'
                      src={item.img}
                      width={item.width}
                      height={item.height}
                      alt='FactsAndFiguresIcon1'
                    />
                  </i>
                </LazyLoad>
                <div className='flex-fill'>
                  <h3 className='h4 font-size-24 mb-1'>
                    {item.num}
                  </h3>
                  <p className='mb-0'>
                    {item.experience}
                  </p>
                </div>
              </div>
            </Col>
          ))
        }

      </Row >
    </>
  )
}

export default WhyChooseFacts;
